import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";
import { GridColumnType } from "../../../../../components/FinalMolGrid/libs/data/gridColumnType";


const initState = {
  userId: '',
}

export const projectTeamFormData = {
  name: "Team Form",
  initialState: initState,
  section: [
    {
      sectionId: 'projectTeam',
      title: "Project Form",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-2 mb-2",
      }, 
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "userId",
          label: "Select User Name",
          Field_Name: "user name",
          fieldType: FormFieldTypes.SELECT,
          dataField: "userId",
          isMultiSelect: true,
          fieldSetting: {
            placeholder: "Please Select User",
            allowSpace: true,
            options: [],
            isMultiSelect:true
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-6 validation-text-model",
          },
        }
      ]
    }
  ]
}

/** Table Column Configration */
export const ProjectTeamGridConfig = {
  columns: [
    {
      name: "User Name",
      fieldName: "userName",
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowDelete: true,
      },
    },
  ],
}
export default projectTeamFormData;